import { render } from "./ProductMain.vue?vue&type=template&id=213ac21d&scoped=true&ts=true"
import script from "./ProductMain.vue?vue&type=script&lang=ts"
export * from "./ProductMain.vue?vue&type=script&lang=ts"

import "./ProductMain.vue?vue&type=style&index=0&id=213ac21d&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213ac21d"]])

export default __exports__